module.exports = __webpack_public_path__ + "static/media/accept-bid-icon.bd8438ca.svg";